import script from "./BentoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BentoCard.vue?vue&type=script&setup=true&lang=js"

import "./BentoCard.vue?vue&type=style&index=0&id=4ed7915e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed7915e"]])

export default __exports__